// Auth Phase 2 (P2-B): the shared look of the public token pages (/forgot,
// /reset-password/:token, /welcome/:token). Same card idiom as
// components/ForcedPasswordReset.js — dark gradient page, gold primary button.
// Kept in its own module so the P2-A component stays untouched.
export const POLICY_MIN = 12;
export const POLICY_MAX = 72;

export const page = {
  minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'linear-gradient(135deg, #0a0a0a 0%, #1E1E1E 100%)', padding: 20
};
export const card = {
  width: '100%', maxWidth: 440, background: '#1E1E1E', color: '#E0E0E0', border: '1px solid #2A2A2A',
  borderRadius: 20, padding: '40px 36px', boxShadow: '0 25px 50px rgba(0,0,0,0.5), 0 0 25px rgba(212,169,78,0.25)'
};
export const logo = { width: 90, display: 'block', margin: '0 auto 14px' };
export const title = { fontSize: 22, fontWeight: 700, color: '#FFFFFF', margin: '0 0 6px', textAlign: 'center' };
export const label = { display: 'block', fontSize: 14, fontWeight: 500, color: '#E0E0E0', marginBottom: 6 };
export const input = {
  width: '100%', boxSizing: 'border-box', padding: '12px 14px', fontSize: 16, borderRadius: 10,
  border: '2px solid #2A2A2A', background: '#141414', color: 'white', outline: 'none', marginBottom: 16
};
export const hint = { fontSize: 13, color: '#A0A0A0', margin: '0 0 18px' };
export const errorText = { fontSize: 13, color: '#EF4444', margin: '0 0 14px' };
export const successText = { fontSize: 15, color: '#22C55E', margin: '0 0 18px', textAlign: 'center' };
export const primary = {
  width: '100%', padding: 14, fontSize: 16, fontWeight: 600, borderRadius: 10, border: 0,
  background: '#D4A94E', color: '#1a1a1a', cursor: 'pointer'
};
export const secondaryLink = { display: 'block', textAlign: 'center', marginTop: 14, fontSize: 14, color: '#D4A94E', textDecoration: 'none' };
export const staticNote = { fontSize: 13, color: '#6B6B6B', marginTop: 18, textAlign: 'center' };
